export default function Disclaimer() { 
	return (
		<div>
		Ⓒ {(new Date().getFullYear())} <a href="https://HouseClowns.com">HouseClowns.com</a>
		</div>
	);
}